// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__jVvSK","extraSmall":"Avatar_extraSmall__meIxS","small":"Avatar_small__cIJyU","medium":"Avatar_medium__rzsd0","large":"Avatar_large__97c9f"};